import { Typography } from "@mui/material";
import { ActivePosition } from "src/types/products";
import { fDecimalNumber } from "src/utils/formatNumber";

export default function Shares({ titles }: ActivePosition) {
	return <Typography variant='subtitle2'>{fDecimalNumber(titles, true)}</Typography>;
}
